import React from 'react';
import {
  Pane,
} from 'evergreen-ui';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { ReportContext } from 'Features/Reports/Report.Context';
import TitleWithCross from 'Utils/TitleWithCross';
import TimeseriesProvider, { TimeseriesContext } from './Timeseries.Context';
import TimeseriesPanelProvider from './Timeseries.Panel.Context';
import TimeseriesPanel, { Modules } from './Timeseries.Panel';
import MeasureSelector from './Timeseries.Panel.MeasureSelector';
import {
  DIRTY_DATA_TABLE_TYPE,
  REPORT_DATA_TABLE_TYPE,
  VIEW_TABLE,
} from './Timeseries.Utils';
import Table from './Timeseries.Table';
import { Charts } from './Timeseries.Charts';

export default function TimeseriesDefault({
  sourceId,
  sourceType,
  tableType,
  posts = [],
  timeZone,
  useGetMeteocodesQuery = () => { },
  useGetStationEntityQuery = () => { },
  useGetDataQuery = () => { },
  columns = [],
  reportOptions = undefined,
  addByDatasourceTypePartition
}) {
  const meteocodeQuery = useGetMeteocodesQuery(undefined, { skip: tableType === REPORT_DATA_TABLE_TYPE });
  const stationEntityQuery = useGetStationEntityQuery(undefined, { skip: tableType === REPORT_DATA_TABLE_TYPE });

  const {
    data: allMeteocodes = [], isFetching: isLoadingMeteocodes,
  } = meteocodeQuery || { data: [], isFetching: false };

  const {
    data: stationEntities = [], isFetching: isLoadingStationEntities,
  } = stationEntityQuery || { data: [], isFetching: false };

  const formattedMeteocodes = React.useMemo(() => {
    const tmp = [];

    allMeteocodes.forEach((meteocode) => {
      const formattedMeteocode = {
        meteoCodeName: meteocode.meteoCodeDetail.name,
        meteoCode: meteocode.meteoCodeDetail.meteoCodeString,
        meteoCodeDescription: meteocode.meteoCodeDetail.description,
        steps: meteocode.steps,
        unit: meteocode.meteoCodeDetail.unit,

        firstReceivedTimeUTC: meteocode.firstReceivedTimeUTC,
        selectedName: meteocode.meteoCodeDetail.meteoCodeString,

      };
      if (meteocode.entities && meteocode.entities.length > 0) {
        meteocode.entities.forEach((entity) => {
          tmp.push({
            ...formattedMeteocode,
            firstReceivedTimeUTC: entity.firstReceived,
            selectedName: `${meteocode.meteoCodeDetail.meteoCodeString}|${entity.stationEntityDTO.id}`,
            entityId: entity.stationEntityDTO.id,
            entityName: entity.stationEntityDTO.labelFromParameters,
          });
        });
      }
      if (meteocode.places && meteocode.places.length > 0) {
        meteocode.places.forEach((place) => {
          tmp.push({
            ...formattedMeteocode,
            firstReceivedTimeUTC: place.firstReceived,
            selectedName: `${meteocode.meteoCodeDetail.meteoCodeString}|${place.place}`,
            placeName: place.place,
          });
        });
      }
      tmp.push(formattedMeteocode);
    });
    return tmp;
  }, [allMeteocodes]);

  if (isLoadingMeteocodes || isLoadingStationEntities) return <SuspenseSpinner />;

  return (
    <TimeseriesProvider
      addByDatasourcePartitionColumns={addByDatasourceTypePartition}
      sourceId={sourceId}
      sourceType={sourceType}
      tableType={tableType}
      allMeteocodes={formattedMeteocodes}
      posts={posts}
      timeZone={timeZone}
      columns={columns}
      reportOptions={reportOptions}
      useGetDataQuery={useGetDataQuery}
    >
      <Pane margin=".5rem" display="grid" gridTemplateRows="max-content 1fr" rowGap=".5rem" overflow="hidden">
        <Pane display="grid" gridAutoFlow="row" gridTemplateRows="max-content" rowGap=".5rem">
          <TimeseriesPanelProvider>
            {tableType === REPORT_DATA_TABLE_TYPE && <ReportName />}
            <TimeseriesPanel>
              {tableType !== DIRTY_DATA_TABLE_TYPE && <Modules.CalcParamsSelector />}
              {tableType !== REPORT_DATA_TABLE_TYPE && <MeasureSelector />}
              {tableType !== DIRTY_DATA_TABLE_TYPE && <Modules.ConfinesSelector />}
              {tableType !== DIRTY_DATA_TABLE_TYPE && <Modules.ChangeViewSelector />}
              {tableType !== DIRTY_DATA_TABLE_TYPE && <Modules.ExportSelector />}
            </TimeseriesPanel>
          </TimeseriesPanelProvider>
        </Pane>
        <RenderByView />
      </Pane>
    </TimeseriesProvider>
  );
}

function RenderByView() {
  const { view } = React.useContext(TimeseriesContext);
  if (view === VIEW_TABLE) return <Table />;
  return <Charts />;
}

export const Timeseries = React.memo(TimeseriesDefault);
Timeseries.displayName = 'Timeseries';

function ReportName() {
  const { reportName } = React.useContext(ReportContext);
  return <TitleWithCross title={`Отчет "${reportName}"`} crossTo=".." />;
}
